enum MenuEnum {
  NAME = 'menu',
  MENU_DETAILS = 'menu_details',
  // 用户token
}
export default MenuEnum;
